import React, { useEffect, useState } from 'react'
import { useRequest } from 'ahooks'
import request from 'meinian-package/src/utils/request'
import Select, { SelectOption } from './select'

const useInspirations = () => {
  const { runAsync } = useRequest(
    async (likeName) => {
      const data = await request.post('/zhikuan/ins/inspiration/list-simple-inspiration?pageSize=99&start=0', { likeName })
      return (data as any)?.resultList.map((m) => ({
        label: m.name,
        value: m.id,
      }))
    },
    { manual: true }
  )

  return runAsync
}
export type SelectInspirationProps = {
  value: string
  onChange: (value: unknown) => void
}
export default function SelectInspirations({ value, onChange }: SelectInspirationProps) {
  const [options, setOptions] = useState<SelectOption[]>([])
  const runAsync = useInspirations()
  const onSearch = async (query: string) => {
    const data = (await runAsync(query)) as SelectOption[]
    setOptions(data)
  }
  useEffect(() => {
    onSearch('')
  }, [])
  return <Select placeholder="全部灵感集" allowClear options={options} onSearch={onSearch} value={value} onChange={onChange} />
}
